// = Libs =
import { FC } from 'react';

// = Styles =
import classes from './filter-set.module.scss';
import CustomInput, { InputTypeType } from '@/components/custom-input/custom-input';

// = Imports =

interface InputField {
  name: string;
  value: string | number | boolean | null;
  text: string;
  input: InputTypeType;
  required?: boolean;
}

interface FilterInterface {
  state: any;
  setState: (newData: any) => any;
  config: InputField[];
}

const FilterSet: FC<FilterInterface> = ({
  state = {},
  setState = () => {},
  config = [],
}) => {
  return (
    <div className={classes.side_container}>
      {config.map((item) => (
        <CustomInput
          name={item.name}
          value={state[item.name]}
          inputType={item.input}
          text={item.text}
          onChange={(newData) => {
            let newState = { ...state };
            newState[item.name] = newData;
            return setState(newState);
          }}
          className={classes.side_input}
          formik={false}
        />
      ))}
    </div>
  );
};

export default FilterSet;
export type { InputField };
